/**
 * Escape SQL LIKE wildcards (`%`, `_`, `\`) in user input so they are treated as literals. Also
 * escapes `*`: PostgREST substitutes `*` for `%` in `like`/`ilike` operand values (so `%` need not
 * be URL-encoded in a query string) — left unescaped, a user-typed `*` would still act as a
 * wildcard even after this function runs.
 *
 * @param input - Raw user input string.
 * @returns Escaped string safe for ilike patterns.
 */
export function escapeIlike(input: string): string {
  return input.replace(/[%_\\*]/g, "\\$&");
}
